<template>
  <div class="content content--efb">
    <MyHeader :breadcrumbItems="[

        {
          name: 'Engage for Business',
          path: this.$route.path
        },
      ]"/>

    <header class="content-header">
      <h1>Engage for Business</h1>
    </header>

    <div class="container main-content article-content">
      <div class="block">
        <div class="block-img">
          <img src="../assets/images/pic-1-1.jpg">
        </div>
        <div class="block-inner">
          <h2>Engage for your business</h2>
          <p>Our main goal in developing Engage is to empower Capgemini’s teams to take a leap in enhancing new digital ways of communication with their clients and stakeholders. Our safe, flexible, digital solution can be used in almost any business situation.</p>
        </div>
      </div>

      <div class="block">
        <div class="block-img">
          <img src="../assets/images/pic-1-2.jpg">
        </div>
        <div class="block-inner">
          <h2>Digital from the start</h2>
          <p>Engage enables you to surprise your clients with a new digital way of communicating and share your curated content in a different way that is also pleasantly familiar.</p>
        </div>
      </div>

      <div class="block">
        <div class="block-img">
          <img src="../assets/images/pic-1-3.jpg">
        </div>
        <div class="block-inner">
          <h2>A versatile and flexible platform</h2>
          <p>Engage is perfect for long-term projects, short events or reasonably long workshops. Thanks to its highly customizable nature, you can choose the modules that suit you best – making your app truly unique.</p>
        </div>
      </div>

      <div class="block">
        <div class="block-img">
          <img src="../assets/images/pic-1-4.jpg">
        </div>
        <div class="block-inner">
          <h2>Implementation and support that’s always there</h2>
          <p>With our end-to-end guidance and hands on support you will get up to speed in the blink of an eye. After go-live, we continue to support you, developing new modules, sharing materials or writing articles on how you can make the best of your new app.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '../components/general/Header'

export default {
  name: "EngageForBusiness",
  components: { MyHeader },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Engage for Business']);
    window._paq.push(['trackPageView']);
  }
}
</script>
